import { DATA_ANALYSIS_MENU_PERMS } from './menuPermissionGroups'

/**
 * PageTop 右上角快捷入口：tab 文案 → getInfo.permissions 中的权限标识（与系统菜单按钮 perms 一致）。
 *
 * 展示条件（均在 TopMenu 组件内完成，调用方只传 :menus 作为「本页允许的候选 tab」）：
 * 1) 父组件 :menus 包含该 tab；
 * 2) 用户 permissions 含 *:*:* 或下列任一标识（与 checkPermi / v-hasPermi 相同）。
 *
 * 后台菜单名「电表读数」对应前端 Tab/快捷入口文案「电表数据」。
 */
export const PAGE_TOP_QUICK_MENU_PERMS = {
  收益总览: ["operate:revenue:query"],
  电价录入: ["operate:electricPrice:query"],
  抄表结算: ["operate:meterSettle:query"],
  主监控: ["device:realtime:query"],
  电站拓扑: ["device:topology:query"],
  储能系统: ["device:storage:query"],
  充放记录: ["device:chargeRecord:query"],
  电表数据: ["operate:meterReading:query"],
  告警管理: ["ops:alarm:query"],
  告警信息: ["ops:alarmInfo:query"],
  策略控制: ["ops:strategy:query"],
  策略模板: ["ops:strategy:module:query"],
  数据分析: DATA_ANALYSIS_MENU_PERMS,
}
